import { render, staticRenderFns } from "./cause.vue?vue&type=template&id=1170d405&scoped=true"
import script from "./cause.vue?vue&type=script&lang=js"
export * from "./cause.vue?vue&type=script&lang=js"
import style0 from "./cause.vue?vue&type=style&index=0&id=1170d405&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1170d405",
  null
  
)

export default component.exports